const {
	SVG,
	Path
} = wp.components;

const EditIcon = <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><rect x="0" fill="none" width="20" height="20"/><Path d="M4 5H2v13h10v-2H4V5zm13.9-1.6l-1.3-1.3c-.4-.4-1.1-.5-1.6-.1l-1 1H5v12h9V9l4-4c.4-.5.3-1.2-.1-1.6zm-5.7 6l-2.5.9.9-2.5L15 3.4 16.6 5l-4.4 4.4z"/></SVG>;
;

export default EditIcon;
